let loader: Promise<any> | null = null;

export const SQFT_PER_SQM = 10.76391041671;

export function loadGoogleMaps(key: string): Promise<any> {
  if (window.google?.maps?.importLibrary) return Promise.resolve(window.google);
  if (loader) return loader;
  loader = new Promise((resolve, reject) => {
    const timer = setTimeout(() => { loader = null; reject(new Error("timeout")); }, 15000);
    window.__iqwMapsReady = () => { clearTimeout(timer); resolve(window.google); };
    window.gm_authFailure = () => {
      (window as any).__iqwMapsAuthFailed = true;
      window.dispatchEvent(new Event("iqw-maps-auth-failure"));
      reject(new Error("auth"));
    };
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&v=weekly&loading=async&libraries=places,geometry,marker&callback=__iqwMapsReady`;
    s.async = true;
    s.onerror = () => { clearTimeout(timer); loader = null; reject(new Error("load")); };
    document.head.appendChild(s);
  });
  return loader;
}

export function ringAreaSqFt(g: any, ring: number[][]): number {
  const path = ring.slice(0, -1).map(([lng, lat]) => new g.maps.LatLng(lat, lng));
  return g.maps.geometry.spherical.computeArea(path) * SQFT_PER_SQM;
}
